import { render } from "./order-fulfillment-import.vue?vue&type=template&id=24f05bc1&scoped=true"
import script from "./order-fulfillment-import.vue?vue&type=script&lang=js"
export * from "./order-fulfillment-import.vue?vue&type=script&lang=js"

import "./order-fulfillment-import.vue?vue&type=style&index=0&id=24f05bc1&scoped=true&lang=css"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f05bc1"]])

export default __exports__